import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Suspense, useLayoutEffect, useState } from "react";
import HeaderDashboard from "../../components/Header/Dashboard";
import { DashboardContainer } from "./styled";
import { useDispatch } from "../../store/store";
import { useEffect } from "react";
import {
  getDataTokenLogin,
  getDataListHistory,
} from "../../store/features/poolsSlice";
import { AVAX_API } from "../../services/api/indexV2";
import { Spin } from "antd";
import {
  useAppKitAccount,
  useAppKitProvider,
  useDisconnect,
  Provider as ProviderEVM,
} from "@reown/appkit/react";
import { useSignMessage } from "wagmi";
import { useSelector } from "react-redux";
import Solflare from "@solflare-wallet/sdk";
import { type Provider } from "@reown/appkit-adapter-solana/react";
import toast from "react-hot-toast";
import { switchDefaultTokens } from "../../constant";
import { useTonAddress, useTonWallet } from "@tonconnect/ui-react";
import { fetchUserProfile } from "../../store/features/profileSlice";

const TON_ADDRESS: any = process.env.REACT_APP_AVAX_ADDRESS;
const KIBBLE_ADDRESS: any = process.env.REACT_APP_USDC_ADDRESS;

const LayoutDashboard = ({ chain }: any) => {
  const { address, isConnected } = useAppKitAccount();
  const { disconnect } = useDisconnect();
  const dispatch = useDispatch();
  const { data: signature, signMessage, reset } = useSignMessage();
  const { listTokens, tokenLogin }: any = useSelector(
    (state: any) => state.pool
  );
  const { walletProvider: providerSolana } =
    useAppKitProvider<Provider>("solana");
  const providerEVM = useAppKitProvider<ProviderEVM>("eip155");
  const [signSol, setSignSol] = useState("");
  const wallet = useTonWallet();
  const addressTon = useTonAddress();
  const location = useLocation();
  const [code, setCode] = useState("");
  const [oauthToken, setOauthToken] = useState("");
  const [oauthVerify, setOauthVerify] = useState("");

  const handleGetHistory = async (listTokens: any[]) => {
    try {
      const { data } = await AVAX_API.getTx();
      const newList = data.data?.map((item: any) => {
        return {
          ...item,
          src_address: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.src_address,
          src_symbol: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.symbol,
          src_img: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.img,
          dest_address: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.dest_address,
          dest_symbol: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.symbol,
          dest_img: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.img,
        };
      });
      dispatch(getDataListHistory(newList));
    } catch (error) {
      console.log("errrr", error);
    }
  };

  const signMessageWithSolana = async () => {
    const message = new TextEncoder().encode("Verify");
    let signature: Uint8Array;
    try {
      if (providerSolana?.name === "Phantom") {
        const res = await window.solana.signMessage(message, "utf8");
        signature = res.signature;
      } else {
        const solflare = new Solflare();
        await solflare.connect();
        signature = await solflare.signMessage(message, "utf8");
      }
      setSignSol(Buffer.from(signature).toString("base64"));
    } catch (error) {
      console.log(error);
      toast.error("User verify failed");
      // localStorage.clear();
      setSignSol("");
      disconnect();
    }
  };

  const handleLogin = async (sign: string) => {
    try {
      if (chain === "Solana" && providerSolana.chain === "solana") {
        const params = {
          message: "Verify",
          publicKey: address,
          signature: signSol,
          wallet_name: "",
        };
        const { data } = await AVAX_API.loginSol(params);
        localStorage.setItem("TOKEN", data.data.token);
        dispatch(getDataTokenLogin(data.data.token));
        handleGetHistory(listTokens);
      } else if (chain === "Toncoin") {
        if (!wallet) return;
        if (
          wallet.connectItems?.tonProof &&
          !("error" in wallet.connectItems.tonProof)
        ) {
          const params = {
            referral_code: "",
            address: wallet.account.address,
            network: Number(wallet.account.chain),
            proof: {
              timestamp: wallet.connectItems.tonProof.proof.timestamp,
              domain: {
                length_bytes:
                  wallet.connectItems.tonProof.proof.domain.lengthBytes,
                value: wallet.connectItems.tonProof.proof.domain.value,
              },
              signature: wallet.connectItems.tonProof.proof.signature,
              payload: wallet.connectItems.tonProof.proof.payload,
              state_init: wallet.account?.walletStateInit,
              public_key: wallet.account?.publicKey,
            },
          };
          const { data } = await AVAX_API.loginTon(params);
          localStorage.setItem("TOKEN", data.data.token);
          dispatch(getDataTokenLogin(data.data.token));
          handleGetHistory(listTokens);
        }
      } else {
        const params = {
          message: "Verify",
          signature: sign,
          wallet_name: "",
        };
        const { data } = await AVAX_API.login(params);
        localStorage.setItem("TOKEN", data.data);
        dispatch(getDataTokenLogin(data.data));
        handleGetHistory(listTokens);
      }
    } catch (error) {
      console.log("handleLogin err", error);
    }
  };

  const handleSignMess = () => {
    if (providerSolana?.chain === "solana" && chain === "Solana" && address) {
      signMessageWithSolana();
    } else {
      signMessage({ message: "Verify" });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("TOKEN");
    if (address) {
      dispatch(getDataTokenLogin(token));
      handleSignMess();
    }
  }, [address, chain]);

  useEffect(() => {
    // disconnect wallet then clear all
    if (!isConnected) {
      // localStorage.clear();
      setSignSol("");
      disconnect();
      reset();
    }
  }, [isConnected]);

  useEffect(() => {
    if (signature && address) {
      handleLogin(signature);
    }
  }, [signature, address]);

  useEffect(() => {
    if (signSol && address) {
      handleLogin(signSol);
    }
  }, [signSol, address]);

  useEffect(() => {
    if (chain === "Toncoin" && addressTon) {
      handleLogin("");
    }
  }, [addressTon]);

  useEffect(() => {
    const token = localStorage.getItem("TOKEN");
    if (!token && address && tokenLogin && tokenLogin === "SIGN") {
      dispatch(getDataTokenLogin(null));
      handleSignMess();
    }
  }, [tokenLogin]);

  useEffect(() => {
    // Save from and to to localStorage
    const getSelectedFromLocal = JSON.parse(
      localStorage.getItem("avax-selectedTokens") || "{}"
    );
    const selectedTokens = {
      from: getSelectedFromLocal.from || TON_ADDRESS,
      to: getSelectedFromLocal.to || KIBBLE_ADDRESS,
    };
    localStorage.setItem("avax-selectedTokens", JSON.stringify(selectedTokens));
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    // Refresh chain when connected wallet had chain difference with active chain
    if (!address) return;

    let connectedChain = "";
    if (providerSolana?.chain === "solana") {
      connectedChain = "Solana";
    } else if (providerEVM !== undefined) {
      connectedChain = "Avalanche";
    }

    if (
      connectedChain &&
      connectedChain.toLowerCase() !== chain?.toLowerCase()
    ) {
      const defaultTokens = switchDefaultTokens(chain);
      navigate(
        `/swap/${connectedChain.toLowerCase()}?from=${
          defaultTokens?.fromAddress
        }&to=${defaultTokens?.toAddress}`,
        { replace: true }
      );
      toast(`You're connected to ${connectedChain}. Redirecting...`);
    }
  }, [address]);

  //get profile
  useEffect(() => {
    if (localStorage.getItem("TOKEN")) {
      dispatch(fetchUserProfile());
    }
  }, [localStorage.getItem("TOKEN")]);

  //get code
  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const codeParam = searchParams.get("code");
    if (codeParam && !code) {
      setCode(codeParam);
    }
  }, [location.search]);

  const handleConnectDiscord = async (code: string) => {
    try {
      await AVAX_API.handleConnectDiscord(code);
    } catch (error) {
      console.error("Connect Discord failed", error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("TOKEN") && code) {
      handleConnectDiscord(code);
    }
  }, [code, localStorage.getItem("TOKEN")]);

  //handle connect twitter
  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauth_token = params.get("oauth_token");
    const oauth_verifier = params.get("oauth_verifier");
    if (oauth_token && oauth_verifier) {
      setOauthToken(oauth_token);
      setOauthVerify(oauth_verifier);
    }
  }, [location.search]);

  const handleConnectTwiiter = async (
    oauthToken: string,
    oauthVerify: string
  ) => {
    try {
      const params = {
        oauth_token: oauthToken,
        oauth_verifier: oauthVerify,
      };
      await AVAX_API.handleCallBackTwitter(params);
    } catch (error) {
      console.error("Connect Discord failed", error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("TOKEN") && oauthToken && oauthVerify) {
      handleConnectTwiiter(oauthToken, oauthVerify);
    }
  }, [oauthToken, oauthVerify, localStorage.getItem("TOKEN")]);

  return (
    <Suspense fallback={<Spin spinning={true} fullscreen />}>
      <HeaderDashboard chain={chain} />
      <DashboardContainer>
        <Outlet />
      </DashboardContainer>
    </Suspense>
  );
};
export default LayoutDashboard;
